<template>
  <article class="article-settings">
    <p class="error" v-if="shouldCreateWorkspace">
      Vous devez créer ou rejoindre un espace.
    </p>
    <div class="form-container">
      <h3>Vos espaces</h3>
      <button @click="create">Créer un nouvel espace</button>
      <div class="workspaces-container">
        <WorkspaceItem
          v-for="(workspace, index) in workspaces"
          :key="index"
          :workspace="workspace"
        />
      </div>
    </div>
  </article>
</template>

<script>
import _ from 'lodash';
import WorkspaceForm from '../Form/WorkspaceForm.vue';
import WorkspaceItem from '../Workspace/WorkspaceItem.vue';

export default {
  components: {
    WorkspaceItem,
  },
  data() {
    return {};
  },
  mounted() {},
  destroyed() {},
  methods: {
    create() {
      this.$modal.show(
        WorkspaceForm,
        {},
        {
          height: 'auto',
        }
      );
    },
  },
  computed: {
    workspaces() {
      return _.get(this.userProfile, 'workspaces', []);
    },
  },
};
</script>

<style lang="scss" scoped src="./Settings.scss"></style>
